import { useTypedSelector } from ".";

export const useUserLogin = ():
  | {
      email: string;
      phone: string;
    }
  | undefined => useTypedSelector(state => state.user.login);
